import type { JSX, RefAttributes } from "react";
import { cloneElement, useCallback, useLayoutEffect, useState } from "react";

interface Props {
  children: JSX.Element;
  onResize: (rect: DOMRectReadOnly) => void;
}

export function ResizeObserverWrapper({ children, onResize }: Props) {
  const [element, setElement] = useState<HTMLElement | null>(null);
  const handleResize = useCallback(
    (entries: ResizeObserverEntry[]) => {
      if (!Array.isArray(entries)) {
        return;
      }

      if (entries[0]?.contentRect) {
        onResize(entries[0].contentRect);
      }
    },
    [onResize]
  );

  useLayoutEffect(() => {
    if (!element) {
      return;
    }

    const ro = new ResizeObserver(handleResize);
    ro.observe(element);

    return () => {
      ro.disconnect();
    };
  }, [element, handleResize]);

  return (
    <>
      {cloneElement(children, {
        ref: setElement,
      } as RefAttributes<HTMLElement>)}
    </>
  );
}
